import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AbstractUserRelatedDataService } from '@y42/feature';
import { UiModelingQuery, UiModelingState, UiModelingStore } from '../../state';

@Injectable({ providedIn: 'root' })
export class UiModelingUserDataService extends AbstractUserRelatedDataService<UiModelingState> {
  constructor(readonly http: HttpClient, readonly store: UiModelingStore, readonly query: UiModelingQuery) {
    super({
      http,
      store,
      query,
      URLs: {
        last_used: 'ui-modeling-last_used',
        starred: 'ui-modeling-starred',
      },
    });
  }
}
